import gql from 'graphql-tag';

export default gql`
  mutation Mutation($desktopId: String!, $courseId: String) {
    retrieveDesktopInstance(desktopId: $desktopId, courseId: $courseId) {
      id
      status
    }
  }
`;
